import { action, computed, makeObservable, observable, runInAction } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import {
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { LoadStatus } from '../../common/enums/load-status';
import { DefaultBrandStore } from '../../settings/main-settings/stores/default-brand.store';
import { AppStore } from '../../common/stores/app.store';

@injectable()
export class AcquisitionSegmentsStore {
    @observable readyState = LoadStatus.None;

    basename = this.routeStore.getPathnameWithStandaloneRoot(
        MarketingSection.Apps,
        MfeBasenames[MarketingMfe.AcquisitionSegments],
    );
    @computed get data() {
        const { street, city, state, zipCode } = this.defaultBrandStore.companyAddress;

        return {
            ...this.appStore.defaultMFEData,
            local: '',
            // @TODO-Sam: backroute should be handled dynamically, as we can redirect to builder page also from details page
            backRoute: '',
            backLabel: 'Back to Audiences',
            builderRouteName: 'build',
            host: 'standalone',
            companyAddress: JSON.stringify({
                street,
                city,
                state,
                zipCode,
            }),
        };
    }

    @computed get source() {
        return `https://unpkg.servicetitan.com/@servicetitan/marketing-acquisition-segments@${this.standaloneRootStore.appSettings.environmentTag}`;
    }

    constructor(
        @inject(DefaultBrandStore) private defaultBrandStore: DefaultBrandStore,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
        @inject(AppStore) private appStore: AppStore,
        @inject(MarketingRouteStore) private readonly routeStore: MarketingRouteStore,
    ) {
        makeObservable(this);
    }

    @action initialize = async () => {
        runInAction(() => {
            this.readyState = LoadStatus.Loading;
        });

        try {
            await this.defaultBrandStore.loadDefaultBrandData();

            runInAction(() => {
                this.readyState = LoadStatus.Ok;
            });
        } catch {
            runInAction(() => {
                this.readyState = LoadStatus.Error;
            });
        }
    };
}
